module.exports = __webpack_public_path__ + "img/New Jersey outline.07880fc0.png";